import { AxiosError, AxiosResponse } from 'axios'
import { axiosInstance } from '../../config/axios.config'
import {
  IAuthCreateErrorResponse,
  IAuthCreateSuccessResponse,
} from '../LoginPage/LoginPage.types'

export interface IPropsCreateNewPasswordPage {
  props?: object
}

export interface IAuthCreatePassword {
  password: string
  confirm_password?: string
  token: string
}

export interface IAuthCreatePasswordError extends IAuthCreatePassword {
  confirm_password: string
}

export function authCreatePassword(
  url: string,
  payload: IAuthCreatePassword,
  callback?: (
    result:
      | AxiosResponse<IAuthCreateSuccessResponse>
      | AxiosError<IAuthCreateErrorResponse>
  ) => void
): void {
  axiosInstance
    .post<IAuthCreateSuccessResponse>(url, payload)
    .then((response) => {
      callback?.(response)
    })
    .catch((error: unknown) => {
      if (error instanceof AxiosError) {
        callback?.(error)
      }
    })
}
